// extracted by mini-css-extract-plugin
export default {"heading":"MM","container":"NM","product_section_row":"OM","carousel":"PM","carouselwide":"QM","carouselwrapper":"RM","blockwrapper":"SM","product_carousel_row":"TM","headingnarrow":"UM","title":"VM"};
    if(module.hot) {
      // 1715188237298
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  